// src/páginas/agenda/SchedulePage.jsx
import React, { useState, useEffect } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import { Calendar, Clock, User, MapPin } from 'lucide-react';
import { getTodayAppointments } from '../../services/sales';

const SchedulePage = () => {
  const [appointments, setAppointments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());
  
  useEffect(() => {
    const loadAppointments = async () => {
      setIsLoading(true);
      try {
        const data = await getTodayAppointments();
        setAppointments(data);
      } catch (error) {
        console.error('Erro ao carregar compromissos:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadAppointments();
  }, [selectedDate]);
  
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h1 className="text-2xl font-bold text-gray-900">Agenda</h1>
        <p className="text-gray-500">Gerencie seus compromissos e reuniões</p>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Calendário */}
        <div className="lg:col-span-2 bg-white rounded-lg shadow-sm p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Calendário</h2>
          <div className="h-96 bg-gray-100 rounded-lg flex items-center justify-center">
            <p className="text-gray-500">Componente de calendário será implementado aqui</p>
          </div>
        </div>
        
        {/* Compromissos do dia */}
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Compromissos de Hoje</h2>
          
          {isLoading ? (
            <div className="animate-pulse space-y-4">
              {[1, 2, 3].map(i => (
                <div key={i} className="h-24 bg-gray-200 rounded"></div>
              ))}
            </div>
          ) : appointments.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-64 text-gray-400">
              <Calendar className="h-12 w-12 mb-2" />
              <p>Não há compromissos agendados para hoje</p>
            </div>
          ) : (
            <div className="space-y-4">
              {appointments.map(appointment => (
                <div key={appointment.id} className="p-4 border rounded-lg">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="font-medium text-gray-900">{appointment.type}</h3>
                    <span className={`px-2 py-1 text-xs rounded-full ${
                      appointment.status === 'confirmed' ? 'bg-green-100 text-green-800' :
                      appointment.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                      'bg-blue-100 text-blue-800'
                    }`}>
                      {appointment.status === 'confirmed' ? 'Confirmado' :
                       appointment.status === 'pending' ? 'Pendente' : 'Agendado'}
                    </span>
                  </div>
                  <div className="text-sm text-gray-600 space-y-1">
                    <div className="flex items-center">
                      <Clock className="w-4 h-4 mr-2" />
                      <span>{appointment.time}</span>
                    </div>
                    <div className="flex items-center">
                      <User className="w-4 h-4 mr-2" />
                      <span>{appointment.clientName}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SchedulePage;